let enabled = true;

export const setGaEnabledStatus = (newStatus: boolean): void => {
  if (typeof newStatus !== "boolean") {
    return;
  }
  enabled = newStatus;
};

export const getGaEnabledStatus = (): boolean => enabled;
